import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

export default class {
	constructor() {
		gsap.registerPlugin(ScrollTrigger);
	}

	skewInAnim = (batch) =>
		gsap.fromTo(
			batch,
			{
				y: 30,
				autoAlpha: 0,
				scale: 1.05,
			},
			{
				y: 0,
				autoAlpha: 1,
				scale: 1,
				duration: 0.76,
				ease: "power3.out",
				stagger: 0.05,
			}
		);

	init() {
		ScrollTrigger.batch("[js-skewin-anim]", {
			start: "top +=100%",
			once: true,
			onEnterBack: this.skewInAnim,
			onEnter: this.skewInAnim,
		});
	}

	setInitialStyles() {
		gsap.set("[js-skewin-anim]", {
			y: 30,
			autoAlpha: 0,
			scale: 1.05,
		});
	}
}
